import { WebVitalsReport } from './types';

const WEB_VITALS_ENDPOINT = '/api/web-vitals';

export const sendWebVitalsReport = async (report: WebVitalsReport) => {
  try {
    await fetch(WEB_VITALS_ENDPOINT, {
      method: 'POST',
      keepalive: true,
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(report),
    });
  } catch {
    return;
  }
};
